import { sfCollection } from "@unlikelystudio/commerce-connector"

import type { InferReturn } from "~/@types/generics"
import { sfFetchWrapper } from "~/lib/shopify/utils/sf-fetch-wrapper"

export type CollectionProductsPageInfo = NonNullable<
  InferReturn<typeof getSfCollection>["collection"]
>["productsPageInfo"]

export const getSfCollection = sfFetchWrapper(sfCollection)("collection")
